import { InspectionRequestDeficiencyViewComponent } from './inspection-request-deficiency-view/inspection-request-deficiency-view.component';

export const components: any[] = [InspectionRequestDeficiencyViewComponent];

export * from './inspection-request-deficiency-view/inspection-request-deficiency-view.component';
